import { render, staticRenderFns } from "./UserSalaryType.vue?vue&type=template&id=9e2b942c&scoped=true"
import script from "./UserSalaryType.vue?vue&type=script&lang=js"
export * from "./UserSalaryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2b942c",
  null
  
)

export default component.exports